import * as React from "react";

import "./Icon.css";

const SvgApplyIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(6,12)">
      <path d="M44.23.3 15 30.41a1 1 0 0 1-1.42 0L3.77 20.29a1 1 0 0 0-1.42 0L.29 22.41a1.06 1.06 0 0 0 0 1.46l10.54 10.85 2.76 2.85a1 1 0 0 0 1.42 0l32.7-33.69a1.06 1.06 0 0 0 0-1.46L45.65.3a1 1 0 0 0-1.42 0" />{" "}
    </g>
  </svg>
);
export default SvgApplyIcon;
